// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AccountDetailsGroupsEnum } from '@shared/utils/Enums/AccountDetailsEnum';
export class VerticalDetailsTypePointer {
    constructor(itemType, groupType, key = null) {
        this._itemType = null;
        this._groupType = null;
        this._key = null;
        this.ItemType = itemType;
        this.GroupType = groupType;
        this._key = key;
    }
    get ItemType() {
        return this._itemType;
    }
    set ItemType(value) {
        this._itemType = value;
    }
    get GroupType() {
        return this._groupType;
    }
    set GroupType(value) {
        this._groupType = value;
    }
    get Key() {
        return this._key;
    }
    set Key(value) {
        this._key = value;
    }
    toString() {
        return JSON.stringify(this);
    }
    toJSON() {
        return {
            ItemType: this._itemType,
            GroupType: this._groupType,
            Key: this._key
        };
    }
    static fromJSON(value) {
        if (isNullOrUndefined(value)) {
            return null;
        }
        const pased = JSON.parse(value);
        if (isNullOrUndefined(pased.ItemType) || isNullOrUndefined(pased.GroupType)) {
            return null;
        }
        if (AccountDetailsGroupsEnum[pased.GroupType] === undefined) {
            return null;
        }
        const key = isValidString(pased.Key) ? pased.Key : null;
        return new VerticalDetailsTypePointer(pased.ItemType, pased.GroupType, key);
    }
}
